const chatSuggestedPrompts = [
  'How can I easily see and manage my money in one place?',
  "What's the best travel rewards credit card right now?",
  'What are the best ways to invest for my future?',
  'How can I take full advantage of tax deductions and credits this year?',
  'What does home affordability look like right now?',
  'How can I consolidate my debt and pay it off faster?',
];

export default chatSuggestedPrompts;
